module.exports = __webpack_public_path__ + "static/media/dashboard-e-commerce.3df0a60a.png";